import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';

export const useDeleteTenant = (tenantId: string) => {
  const queryClient = useQueryClient();

  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: () =>
      apiRequest<void>({
        method: 'DELETE',
        url: `${apiHost}/tenants/${tenantId}`,
      }),
    onSuccess: (tenantId) => {
      queryClient.invalidateQueries({
        queryKey: ['tenant', tenantId],
      });
    },
  });
};
